import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { QuizModalComponent } from '../../quiz/quiz-modal/quiz-modal.component';

interface NavItem {
  route: string;
  label: string;
  title: string;
  baseIcon: string;
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent {
  @Output() toggleSidebarEvent = new EventEmitter<boolean>();
  @Output() mobileMenuCloseEvent = new EventEmitter<boolean>();
  @Input() isMobileMenuClosed!: boolean;
  @Input() isMobile!: boolean;

  isSidebarToggled = false;

  navItems: NavItem[] = [
    { route: '/dashboard', label: 'My Tests', title: 'My Tests', baseIcon: 'my-tests' },
    { route: '/results-database', label: 'Results Database', title: 'Results Database', baseIcon: 'results-db' },
    { route: '/profile-settings/personal-information', label: 'My Profile', title: 'Profile', baseIcon: 'profile' },
    { route: '/subscriptions', label: 'Subscriptions', title: 'Subscriptions', baseIcon: 'subscriptions-icon' },
  ];

  constructor(private router: Router, private dialog: MatDialog) {}

  toggleSidebarMenu(): void {
    this.isSidebarToggled = !this.isSidebarToggled;
    this.toggleSidebarEvent.emit(this.isSidebarToggled);
  }

  toggleMobileMenu(): void {
    this.isMobileMenuClosed = !this.isMobileMenuClosed;
    this.mobileMenuCloseEvent.emit(this.isMobileMenuClosed);
  }

  isActive(route: string): boolean {
    return this.router.isActive(route, true);
  }

  /**
   * Returns the correct icon path based on the current state:
   * - Whether the route is active.
   * - Whether the view is mobile or desktop.
   */
  getIconPath(navItem: NavItem): string {
    const active = this.isActive(navItem.route);
    let basePath = './assets/images/svg/sidebar/options/';
    if (this.isMobile) {
      basePath += 'mobile/';
      basePath += navItem.baseIcon + (active ? '-active-mobile.svg' : '-mobile.svg');
    } else {
      basePath += navItem.baseIcon + (active ? '-active.svg' : '.svg');
    }
    return basePath;
  }

  openQuizGenerationDialog(): void {
    this.dialog.open(QuizModalComponent).afterClosed().subscribe();
  }
}
